// #BACE60 -> #2B96D8
export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#0D1C36',
    light: '#6D6F73',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#559CFF',
    light: '#D9EDF7',
    contrastText: '#FFFFFF',
  },
  text: {
    primary: '#23262F',
    secondary: '#4A596F',
    light: '#64748B',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    link: '#90D0FF',
    border: '#E5EAF4',
    header: '#559CFF',
    greySubtle: '#626D7C',
    greySubtle2: '#414651',
    terms: '#559CFF',
    promotion: '#00786F',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#F7F7F7',
    paper: '#FFF',
    default: '#FFF',
    header: 'rgba(225, 242, 255, 0.6)',
    footer: '#F7F7F7',
    level2: '#f7f8fb',
    level1: '#FFF',
    steps: '#000000',
    tableHead: '#000000',
    tableSubhead: '#F7F7F7',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#d4f1f9',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#262626',
    secondary: 'rgb(240,243,243)',
    light: '#F7F7F7',
    secondaryLight: '#FBF7F5',
    freebie: 'rgba(224, 237, 255, 0.3)',
    greySubtle: '#FCFCFC',
    slateLevel1: '#F1F5F9',
    promotion: '#DDFFF8',
    serviceIcon: '#F8FAFC',
  },
  verticalBar: {
    used: '#000000',
    unused: '#6D6F73',
    unlimited: '#C0C0C0',
  },
  border: {
    primary: '#E2E8F0',
    secondary: '#F1F5F9',
    normal: '#CAD5E2',
    blue: '#178BE4',
    error: '#EB4D4B',
  },
  hover: {
    shade: '#0F0F0F',
  },
};
